<div class="tw-app-container tw-px-4 tw-text-secondary">
  <div class="tw-bg-[#F5F5F5] tw-rounded tw-grid tw-gap-4 tw-justify-items-center tw-py-10 tw-px-8">
    <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-justify-center">
      <div class="tw-font-bold tw-text-2xl tw-font-sans">お問い合わせ</div>
      <div>お困りごとがあればご連絡ください</div>
    </div>

    <a href="tel:03-4500-1497" appFlatButton flatButtonStyle="border-secondary" class="tw-bg-white tw-gap-2 tw-px-16 tw-flex-wrap">
      <div class="tw-flex tw-items-center">
        <app-svg-icon class="tw-h-[30px] tw-aspect-square tw-flex-shrink-0" src="/assets/icons/phone.svg" />
        <span class="tw-tabular-nums tw-font-bold tw-text-[22px] tw-flex-shrink-0">03-4500-1497</span>
      </div>
      <div class="tw-flex-shrink-0">※受付時間：平日11:00-18:00</div>
    </a>

    <a
      href="https://about.dealers-stock.jp/inquiry"
      target="_blank"
      appFlatButton
      flatButtonStyle="border-secondary"
      class="tw-bg-white tw-gap-2 tw-px-16 tw-flex-wrap"
    >
      <div class="tw-flex-shrink-0">お問い合わせフォーム</div>
    </a>
  </div>
</div>
